export const TOP_RATED_MIN_AVERAGE_RATING = 4.3;
export const TOP_RATED_MIN_REVIEW_COUNT = 10;
function roundToOneDecimal(value) {
    return Math.round(value * 10) / 10;
}
export function isTopRated(averageRating, reviewCount) {
    return (typeof averageRating === 'number' &&
        typeof reviewCount === 'number' &&
        reviewCount >= TOP_RATED_MIN_REVIEW_COUNT &&
        roundToOneDecimal(averageRating) >= TOP_RATED_MIN_AVERAGE_RATING);
}
